import { SelectionModel } from '@angular/cdk/collections';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CasoDto } from '@models/caso/casoDto.model';
import { CasoFilter } from '@models/caso/casoFilter.model';
import { CasoService } from '@services/caso/caso.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoCasoService } from '@services/tipoCaso/tipoCaso.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { CuerpoDialogCrudRead, DatoDialogCrudRead } from '@models/base/cuerpoDialogCrudRead.model';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from '@component/button-new/button-new.component';
import { SelectUsuariosEmpresaComponent } from '@component/select-usuarios-empresa/select-usuarios-empresa.component';
import { SinDatosParaMostrarComponent } from '@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { DialogFormCasoComponent } from '../dialog-form-caso/dialog-form-caso.component';
import { DialogParams } from '@interfaces/dialogParam.interface.model';

@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule,  MatTooltipModule, MatSortModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, MatNativeDateModule, MatSelectModule, MatRadioModule, A11yModule, MatCheckboxModule,  ButtonFilterTableClearComponent],
  selector: 'app-list-caso',
  templateUrl: './list-caso.component.html',
  styleUrls: ['./list-caso.component.css'],
})
export class ListCasoComponent {
  data = false;
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<CasoDto>();
  formBuilder: FormBuilder = new FormBuilder();
  formFilter: any;
  casoFilter!: CasoFilter;
  checkedFiltroAvanzado: boolean = false;
  tiposCasos: BaseDto[] = [];
  actionType: string = 'view'; // Puede ser 'view', 'edit' o 'new'
  actionIcon: string = 'visibility'; // Iconos de Material (cambiar según la acción)
  initialSelection = [];
  allowMultiSelect = true;
  selection: any;

  accionesDialog = AccionesDialog;
  filtro: CasoFilter = new CasoFilter;
  filtroCasoGuardado!: string | null;
  estadosCaso!: BaseDto[];
  constructor(
    private casoService: CasoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private tipoCasoService: TipoCasoService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.breakpointObserver
      .observe(['(max-width: 600px)'])
      .subscribe((result) => {
        this.displayedColumns = result.matches
          ? ['select', 'caratula', 'accion']
          : [
            'select',
            'caratula',
            'fechaComienzo',
            'fechaFinalizacion',
            'tipoCaso',
            'estadoCaso',
            'activo',
            'accion',
          ];
      });

    this.formFilter = this.formBuilder.group({
      Caratula: [null],
      FechaComienzoDesde: [null],
      FechaComienzoHasta: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      FechaFinalizacionHasta: [null],
      FechaFinalizacionDesde: [null],
      IdEstadoCaso: [null],
      IdTipoCasoCaso: [null],
    });

    this.selection = new SelectionModel<CasoDto>(this.allowMultiSelect, this.initialSelection);
  }

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  ngOnInit(): void {
    this.getAllTiposCasos();

    this.filtroCasoGuardado = localStorage.getItem('filtroCasoGuardado');
    if (this.filtroCasoGuardado) {
      this.filtro = JSON.parse(this.filtroCasoGuardado);
      this.formFilter.patchValue(this.filtro);
    }
  }

  guardarFiltro() {
    this.filtro = this.formFilter.value;
    localStorage.setItem('filtroCasoGuardado', JSON.stringify(this.filtro));
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroCasoGuardado');
  }

  aplicarFiltro(filtro: CasoFilter = this.formFilter.value) {

    this.getAllByFilter(filtro);
    this.guardarFiltro();
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAllByFilter(casoFilter: CasoFilter) {
    this.spinner.show('spListado');
    this.casoService.getAllCasoByFilter(casoFilter).subscribe(
      (data) => {
        this.spinner.hide('spListado');
        this.dataSource.data = data;
        this.data = this.dataSource.data.length >= 1 ? true : false;
      },
      (error) => {
        this.spinner.hide('spListado');
        this.snackBar.showError(error, 'Error');
      }
    );
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true) this.checkedFiltroAvanzado = true;
    else this.checkedFiltroAvanzado = false;

    this.getAllTiposCasos();
  }

  getAllTiposCasos() {
    this.spinner.show('spBusquedaTipoCasos');
    this.tipoCasoService.getAll().subscribe(
      (data) => {
        this.spinner.hide('spBusquedaTipoCasos');
        let todos = new BaseDto();
        todos.id = 0;
        todos.descripcion = 'Todos';
        data.push(todos);
        this.tiposCasos = data;
      },
      (error) => {
        this.spinner.hide('spBusquedaTipoCasos');
        this.snackBar.showError(error, 'Error');
      }
    );
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
        case AccionesDialog.Ver:
          dialogConfig.width = "70%"
          break;

        default:
          dialogConfig.width = "50%"
          break;
      }

    const dialogRef = this.dialog.open(DialogFormCasoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }
}
